import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
    disabledLink: PropTypes.bool,
    sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
    const theme = useTheme();
    const PRIMARY_LIGHT = theme.palette.primary.light;
    const PRIMARY_MAIN = theme.palette.primary.main;
    //const PRIMARY_DARK = theme.palette.primary.dark;

    const logo = (
        <Box sx={{ width: 40, height: 40, ...sx }}>
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 485 560">
                <defs>
                    <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
                        <stop offset="0%" stopColor={PRIMARY_LIGHT} />
                        <stop offset="100%" stopColor={PRIMARY_MAIN} />
                    </linearGradient>
                </defs>

                <g>
                    <path
                        d="m185.09432,412.81982l-47.457,2.2578c-1.8945,0 -3.5273,-1.0977 -4.3086,-2.6914l-43.855,-94.102l52.094,36.613l-35.277,-105.23l55.418,53.684l-5.7852,-128.97l68.496,101.34l6.6992,-63.25l20.281,55.012l36.793,-122.63l3.3672,139.45l30.758,-35.543l-3.1367,49.445l76.301,-74.332l-51.953,153.56l49.562,-18.41l-31.344,53.66l0.01563,0.00781c-0.90234,1.5391 -2.5312,2.3906 -4.1992,2.3711l-52.293,-1.2695l9.5742,-57.562l-39.598,35.246l-5.9961,-41.793l-6.9414,22.496l-14.211,-22.379l-3.5039,27.562l-33.445,-44.742l-1.1289,63.723l-30.637,-21.406l5.707,37.859l0.00377,0.02319z"
                        id="svg_15"
                        fill="url(#BG3)"
                    />
                    <path
                        d="m246.79829,2.4922l116.92,67.504l-0.00781,0.01563l116.89,67.488l4.3555,2.5156l0,279.9l-4.3555,2.5156l-116.89,67.488l0.00781,0.01562l-116.92,67.504l-4.3203,2.4922l-4.3203,-2.4922l-116.92,-67.504l0.00781,-0.01562l-116.89,-67.488l-4.3555,-2.5156l0,-279.9l4.3555,-2.5156l116.89,-67.488l-0.00781,-0.01563l116.92,-67.504l4.3203,-2.4922l4.3203,2.4922zm-4.3203,27.438l-85.789,49.531l0.00781,0.01563l-130.77,75.504l0,249.96999l130.77,75.50401l-0.00781,0.01562l85.789,49.531l85.789,-49.531l-0.00781,-0.01563l130.77,-75.504l0,-249.97l-130.77,-75.504l0.00781,-0.01562l-85.789,-49.531z"
                        id="svg_16"
                        fill="url(#BG3)"
                    />
                </g>
            </svg>
        </Box>
    );

    if (disabledLink) {
        return <>{logo}</>;
    }

    return <a href="/">{logo}</a>;
}
